import moment from "@/services/moment";

// 経路検索→予約の場合のqueryの変換(時刻)
export const convertQueryTime = (time) => {
  if (time == undefined || time == null) {
    return moment(new Date()).format("HH:mm");
  } else {
    const hm = time.match(/.{2}/g);
    return hm[0] + ":" + hm[1];
  }
};
